import { PageShell } from '../components/PageShell.js';
import { Icons, StateCard } from '../components/StateCard.js';
import { FALLBACK_THEME } from '../lib/theme.js';

/**
 * A URL this site has no route for.
 *
 * Distinct from the API's uniform 404, which `FailureView` renders: this one is
 * about the address, not the event, so there is no theme to wear — the fallback
 * palette is the honest one. Both read the same way to an attendee, which is
 * the point.
 */
export function NotFoundPage() {
  return (
    <PageShell theme={FALLBACK_THEME} width="reading">
      <StateCard
        icon={Icons.compass}
        title="That page isn't here"
        body="The address does not match anything on this site."
        hint="If you followed a link from an email, open it straight from the message rather than pasting it — long links are easy to clip."
      />
    </PageShell>
  );
}
